<div class="user-container">
<img [src]="displayImg(imageSrc)" class="img" [ngClass]="small ? 'size-sm' : 'size-md'" alt="user_img">
  <div>
    <div class="{{small ? 'fs-13 fw-4' : 'fs-16 fw-7'}}" *ngIf="text">{{text}}</div>
    <div class="{{small ? 'fs-13 fw-4' : 'fs-16'}}" *ngIf="email">{{email}}</div>
    <div *ngIf="phoneNumber">{{phoneNumber}}</div>
    <app-rating *ngIf="withRating"
                (onClick)="rating($event)"
                [rating]="4"
                [readOnly]="true"
                [width]="14"
                [height]="14"></app-rating>
  </div>
</div>
